export default "__VITE_ASSET__4191540c__"